export default {
  "config": {
    "trial": "tones-5",
    "id": "ess-groupb",
    "type": "line",
    "title": "Epworth Sleepiness Scale (ESS) Scores During the Maintenance Phase (Group B,<sup>a</sup> Safety Population)<sup>14</sup>",
    "xAxis": {
      "groups": [
        "0",
        "2",
        "14",
        "26",
        "39",
        "52"
      ],
      "padding": 0.1,
      "label": {
        "text": "Week"
      },
      "overrides": {
        "0": "Baseline of<br>current study"
      },
      "shadedRegion": [],
      "scale": "scaleBand"
    },
    "yAxis": {
      "low": 0,
      "high": 25,
      "inc": 5,
      "label": {
        "text": [
          "ESS score, <no-break>mean ± SD</no-break>"
        ]
      }
    },
    "legend": [
      {
        "entry": "overall",
        "label": "Overall<sup>b</sup> <no-break>(N = 124)</no-break>",
        "color": "#006e8a",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Overall"
      },
      {
        "entry": "osa",
        "label": "OSA<sup>b</sup> <no-break>(n = 84)</no-break>",
        "color": "#414100",
        "line": "solid",
        "shape": "dot",
        "tooltip": "OSA"
      },
      {
        "entry": "narcolepsy",
        "label": "Narcolepsy<sup>b</sup> <no-break>(n = 40)</no-break>",
        "color": "#d65a00",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Narcolepsy"
      }
    ],
    "footnotes": [
      "<sup>a</sup>Group B included participants with narcolepsy or OSA who completed one of the <no-break>phase 2</no-break> studies (NCT01485770, NCT01681121, NCT0286908, and NCT02806895)<sup>5,21</sup> or the <no-break>6-week,</no-break> <no-break>phase 3</no-break> study (NCT02348619)<sup>25</sup> and were subsequently enrolled into this <no-break>long-term</no-break> study. These participants had a study duration for <no-break>52 weeks.</no-break>",
      "<sup>b</sup>Solriamfetol doses include <no-break>37.5 mg,</no-break> <no-break>75 mg,</no-break> <no-break>150 mg,</no-break> and <no-break>300 mg.</no-break>"
    ],
    "useFootnoteTooltip": true,
    "trendLines": [
      {
        "y": 10,
        "color": "#000",
        "label": {
          "text": "Normal range",
          "textColor": "#000"
        },
        "lineType": "dashed"
      }
    ],
    "tooltipHeaders": [
      "Group",
      "Score"
    ],
    "nValueTable": {
      "type": "regular",
      "rows": 1,
      "sourceField": "y"
    },
    "chartLegend": [
      {
        "active": true,
        "entries": [
          {
            "entry": "overall",
            "label": "Overall<sup>b</sup> <no-break>(N = 124)</no-break>",
            "color": "#006e8a",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Overall"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "osa",
            "label": "OSA<sup>b</sup> <no-break>(n = 84)</no-break>",
            "color": "#414100",
            "line": "solid",
            "shape": "dot",
            "tooltip": "OSA"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "narcolepsy",
            "label": "Narcolepsy<sup>b</sup> <no-break>(n = 40)</no-break>",
            "color": "#d65a00",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Narcolepsy"
          }
        ]
      }
    ]
  },
  "data": [
    {
      "name": "overall",
      "color": "#006e8a",
      "sets": [
        {
          "name": "overall",
          "color": "#006e8a",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Overall, mean",
          "tooltipLabel": "Overall",
          "points": [
            {
              "x": 0,
              "y": 15.94,
              "extreme": {
                "upper": 4.18,
                "lower": 4.18
              },
              "label": {
                "text": 15.94,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 2,
              "y": 7.8,
              "extreme": {
                "upper": 5.48,
                "lower": 5.48
              },
              "label": {
                "text": 7.8,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 14,
              "y": 7.3,
              "extreme": {
                "upper": 5.15,
                "lower": 5.15
              },
              "label": {
                "text": 7.3,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 26,
              "y": 7.3,
              "extreme": {
                "upper": 5.2,
                "lower": 5.2
              },
              "label": {
                "text": 7.3,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 39,
              "y": 7.5,
              "extreme": {
                "upper": 5.31,
                "lower": 5.31
              },
              "label": {
                "text": 7.5,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 52,
              "y": 7.6,
              "extreme": {
                "upper": 5.09,
                "lower": 5.09
              },
              "label": {
                "text": 7.6,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            }
          ]
        }
      ]
    },
    {
      "name": "osa",
      "color": "#414100",
      "sets": [
        {
          "name": "osa",
          "color": "#414100",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "OSA, mean",
          "tooltipLabel": "OSA",
          "points": [
            {
              "x": 0,
              "y": 15.02,
              "extreme": {
                "upper": 4.006,
                "lower": 4.006
              },
              "label": {
                "text": 15.02,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 2,
              "y": 6.7,
              "extreme": {
                "upper": 4.76,
                "lower": 4.76
              },
              "label": {
                "text": 6.7,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 14,
              "y": 6.1,
              "extreme": {
                "upper": 4.3,
                "lower": 4.3
              },
              "label": {
                "text": 6.1,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 26,
              "y": 5.9,
              "extreme": {
                "upper": 4.21,
                "lower": 4.21
              },
              "label": {
                "text": 5.9,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 39,
              "y": 6,
              "extreme": {
                "upper": 3.91,
                "lower": 3.91
              },
              "label": {
                "text": 6,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 52,
              "y": 6.3,
              "extreme": {
                "upper": 4.06,
                "lower": 4.06
              },
              "label": {
                "text": 6.3,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            }
          ]
        }
      ]
    },
    {
      "name": "narcolepsy",
      "color": "#d65a00",
      "sets": [
        {
          "name": "narcolepsy",
          "color": "#d65a00",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Narcolepsy, mean",
          "tooltipLabel": "Narcolepsy",
          "points": [
            {
              "x": 0,
              "y": 17.85,
              "extreme": {
                "upper": 3.926,
                "lower": 3.926
              },
              "label": {
                "text": 17.85,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 2,
              "y": 10.2,
              "extreme": {
                "upper": 6.19,
                "lower": 6.19
              },
              "label": {
                "text": 10.2,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 14,
              "y": 9.9,
              "extreme": {
                "upper": 5.84,
                "lower": 5.84
              },
              "label": {
                "text": 9.9,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 26,
              "y": 10.2,
              "extreme": {
                "upper": 5.9,
                "lower": 5.9
              },
              "label": {
                "text": 10.2,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 39,
              "y": 10.6,
              "extreme": {
                "upper": 6.49,
                "lower": 6.49
              },
              "label": {
                "text": 10.6,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 52,
              "y": 10.3,
              "extreme": {
                "upper": 6,
                "lower": 6
              },
              "label": {
                "text": 10.3,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            }
          ]
        }
      ]
    }
  ]
};